import faq from "../assets/images/Sidebar/Question.svg";
import support from "../assets/images/Sidebar/support.svg";
import documentation from "../assets/images/Sidebar/documentation.svg";
import overview from "../assets/images/Sidebar/overview.svg";
import misreport from "../assets/images/Sidebar/mis-report.svg";
import valuechain from "../assets/images/Sidebar/value-chain.svg";
import valuechainpartner from "../assets/images/Sidebar/value-chain-partner.svg";
import valuechainrequest from "../assets/images/Sidebar/value-chain-request.svg";
import masters from "../assets/images/Sidebar/masters.svg";
import rolesnpermission from "../assets/images/Sidebar/rolesnpermission.svg";
import facility from "../assets/images/Sidebar/facility.svg";
import scope1 from "../assets/images/Sidebar/scope1.svg";
import scope2 from "../assets/images/Sidebar/scope2.svg";
import scope3 from "../assets/images/Sidebar/scope3.svg";
import scope4 from "../assets/images/Sidebar/scope4.svg";
import gri from "../assets/images/Sidebar/gri.svg";
import brsr from "../assets/images/Sidebar/brsricon.svg";
import watermanagement from "../assets/images/Sidebar/watermanagement.svg";
import setting from "../assets/images/Sidebar/setting.svg";
import approval from "../assets/images/Sidebar/approval.svg";
import social from "../assets/images/socialblack.svg";
import governance from "../assets/images/govblack.svg";
import environment from "../assets/images/envblack.svg";
import esgreporting from "../assets/images/esgreporting.svg";
import setup from "../assets/images/setup.svg";
import SendIcon from "@mui/icons-material/Send";
import StarBorder from "@mui/icons-material/StarBorder";
import vehiclemaster from "../assets/images/Sidebar/vehiclemaster.svg";
import transportmaster from "../assets/images/Sidebar/transportmaster.svg";
import watermaster from "../assets/images/Sidebar/wastermaster.svg";
import steammaster from "../assets/images/Sidebar/steammaster.svg";
import purchasemaster from "../assets/images/Sidebar/purchasemaster.svg";
import machinemaster from "../assets/images/Sidebar/machinemaster.svg";
import industryprocess from "../assets/images/Sidebar/industryprocess.svg";
import industryequipment from "../assets/images/Sidebar/industryequipment.svg";
import electricitymaster from "../assets/images/Sidebar/electricitymaster.svg";
import heatmaster from "../assets/images/Sidebar/heatmaster.svg";
import initialQuestionare from "../assets/images/initialquestionare.svg";
import productionRevenue from "../assets/images/productionrevenue.svg";
import ghgicon from "../assets/images/ghgicon.svg";
import scopeoverview from "../assets/images/Sidebar/scopeoverview.svg";
import purchasegoods from "../assets/images/Sidebar/purchasegoods.svg";
import upstreamleasedassets from "../assets/images/Sidebar/UpstreamLeasedAssets.svg";
import wastegenerated from "../assets/images/Sidebar/wastegenerated.svg";
import businesstravel from "../assets/images/Sidebar/businesstravel.svg";

export let durationObj = [
  { id: "1M", label: "Current Month" },
  { id: "6M", label: "Last 6 Months" },
  { id: "12M", label: "Last 12 Months" },
];

export const FuelTypeEnum = [
  "Natural Gas",
  "Coal",
  "Petroleum/Gasoline",
  "Diesel",
  "Fuel Oil",
  "LPG",
  "Propane",
];

export const fuelConsumptionUnits = ["Ltr per hour", "Kg per hour", "Kwh"];

export const allowedTypes = [
  "text/csv",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
  "application/vnd.ms-excel", // .xls
  "image/png",
];

export const maxFileSize = 5 * 1024 * 1024; // 5 MB

export const monthsName = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const monthSort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const fuelTypeToUnits = {
  Diesel: ["Ltr per hour"],
  "Petroleum/Gasoline": ["Ltr per hour"],
  Coal: ["kWh"],
  Electricity: ["kWh"],
  "Natural Gas": ["kg per hour"],
  "Fuel Oil": ["Ltr per hour"],
  LPG: ["Ltr per hour"],
  Propane: ["Ltr per hour"],
};

export const years = [2022, 2023, 2024, 2025];

export const monthlist = [
  { id: 1, month: "Jan", value: "01" },
  { id: 2, month: "Feb", value: "02" },
  { id: 3, month: "Mar", value: "03" },
  { id: 4, month: "Apr", value: "04" },
  { id: 5, month: "May", value: "05" },
  { id: 6, month: "Jun", value: "06" },
  { id: 7, month: "Jul", value: "07" },
  { id: 8, month: "Aug", value: "08" },
  { id: 9, month: "Sep", value: "09" },
  { id: 10, month: "Oct", value: "10" },
  { id: 11, month: "Nov", value: "11" },
  { id: 12, month: "Dec", value: "12" },
];

export const quarterlist = [
  { id: 1, month: "Jan-Mar", value: "1" },
  { id: 2, month: "Apr-Jun", value: "2" },
  { id: 3, month: "Jul-Sep", value: "3" },
  { id: 4, month: "Oct-Dec", value: "4" },
];

export const quarterlist1 = [
  { id: 1, month: "Q1", value: "1" },
  { id: 2, month: "Q2", value: "2" },
  { id: 3, month: "Q3", value: "3" },
  { id: 4, month: "Q4", value: "4" },
];

export const sidebarElements = [
  {
    subData: [
      {
        path: "/dashboard",
        primary: "Overview",
        icon: overview,
        openAnotherSidebar: true,
        nextSidebar: "subElements",
      },
      {
        path: "/mis-report",
        primary: "MIS Reports",
        icon: misreport,
      },
      {
        path: "/water-management/dash-board",
        primary: "Water Management",
        icon: watermanagement,
      },
    ],
  },
  {
    heading: "GHG Accounting",
    icon: scope1,
    subData: [
      {
        path: "/scope1/dashboard",
        primary: "Scope 1",
        icon: scope1,
      },
      {
        path: "/scope2/dashboard",
        primary: "Scope 2",
        icon: scope2,
      },
      {
        path: "/scope3/dashboard",
        primary: "Scope 3",
        icon: scope3,
      },
      {
        path: "/scope4/dashboard",
        primary: "Scope 4",
        icon: scope4,
      },
    ],
  },
  {
    heading: "ESG Reporting",
    subData: [
      {
        path: "/brsr/instructions",
        primary: "BRSR",
        icon: brsr,
        moduleName: "ESG Reporting | BRSR",
      },
      {
        path: "/gri/general-disclosure/2-1",
        primary: "GRI",
        icon: gri,
        moduleName: "ESG Reporting | GRI",
      },
    ],
  },

  {
    heading: "Value Chain Consolidation",
    subData: [
      {
        path: "/value-chain/dashboard",
        primary: "Value Chain",
        icon: valuechain,
      },
      {
        path: "/value-chain-partner/upstream",
        primary: "Value Chain Partner",
        icon: valuechainpartner,
      },
      {
        path: "/value-chain-request/sent",
        primary: "Value Chain Request",
        icon: valuechainrequest,
      },
    ],
  },
  {
    heading: "Setup",
    subData: [
      {
        path: "/setup/masters/scope1/industrial-process",
        primary: "Masters",
        icon: masters,
      },
      {
        path: "/setup/roles-permission",
        primary: "Roles and Permissions",
        icon: rolesnpermission,
      },
      {
        path: "/setup/facility-master",
        primary: "Facility Masters",
        icon: facility,
      },
    ],
  },
  {
    heading: "Misc",
    subData: [
      {
        path: "/faq",
        primary: "FAQ",
        icon: faq,
      },
      {
        path: "/ticket",
        primary: "Support",
        icon: support,
      },
      {
        path: "/documentation/scope1/stationary-combustion",
        primary: "Documentation",
        icon: documentation,
      },
      {
        path: "/settings",
        primary: "Settings",
        icon: setting,
      },
    ],
  },
];

export const miniSidebarElements = [
  {
    title: "Overview",
    icon: overview,
    primary: "Overview",
    path: "/dashboard",
    moduleName: "Dashboard",
  },
  {
    title: "MIS Reports",
    icon: misreport,
    primary: "MIS Reports",
    path: "/mis-report",
    moduleName: "Reports",
  },
  {
    title: "Environment",
    icon: environment,
    primary: "Scope 1",
    path: "/scope1/dashboard",
    moduleName: "Environment",
  },
  {
    title: "Social",
    icon: social,
    primary: "Social",
    path: "/social/dashboard",
    moduleName: "Social",
  },
  {
    title: "Governance",
    icon: governance,
    primary: "Governance",
    path: "/governance/dashboard",
    moduleName: "Governance",
  },
  {
    title: "ESG Reporting",
    icon: esgreporting,
    primary: "ESG Reporting",
    path: "/brsr/instructions",
    pathLink1: "/brsr",
    pathLink2: "/gri",
    moduleName: "ESG Reporting",
  },
  {
    title: "Production & Revenue",
    path: "/production-revenue",
    primary: "Production & Revenue",
    icon: productionRevenue,
    moduleName: "Production & Revenue",
  },
  {
    title: "Value Chain Consolidation",
    icon: valuechain,
    primary: "Value Chain",
    path: "/value-chain/dashboard",
    moduleName: "Value Chain",
  },
  {
    title: "Setup",
    icon: setup,
    primary: "Masters",
    path: "/setup/masters/scope1/industrial-process",
    moduleName: "Setup",
  },
  {
    title: "Support",
    icon: support,
    primary: "Support",
    path: "/ticket",
  },
  {
    title: "FAQ",
    icon: faq,
    primary: "FAQ",
    path: "/faq",
  },
  {
    title: "Documentation",
    icon: documentation,
    primary: "Documentation",
    path: "/documentation/scope1/stationary-combustion",
    moduleName: "Documentation",
  },
  // {
  //   heading: "Approval",
  //   path: "/approval/scope1/stationary-combustion",
  //   icon: approval,
  //   // moduleName: "Approval",
  // },
  {
    title: "Settings",
    icon: setting,
    primary: "Settings",
    path: "/settings",
  },
];

export const miniSidebarElementsFacility = [
  {
    title: "Overview",
    icon: overview,
    primary: "Overview",
    path: "/dashboard",
    moduleName: "Dashboard",
  },
  {
    title: "Environment",
    icon: environment,
    primary: "Scope 1",
    path: "/scope1/dashboard",
    moduleName: "Environment",
  },
  {
    title: "Production & Revenue",
    path: "/production-revenue",
    primary: "Production & Revenue",
    icon: productionRevenue,
    moduleName: "Production & Revenue",
  },

  {
    title: "Value Chain Consolidation",
    icon: valuechain,
    primary: "Value Chain",
    path: "/value-chain/dashboard",
    moduleName: "Value Chain",
  },
  {
    title: "Setup",
    icon: setup,
    primary: "Masters",
    path: "/setup/masters/scope1/industrial-process",
    moduleName: "Setup",
  },
  {
    title: "Support",
    icon: support,
    primary: "Support",
    path: "/ticket",
  },
  {
    title: "FAQ",
    icon: faq,
    primary: "FAQ",
    path: "/faq",
  },
  {
    title: "Documentation",
    icon: documentation,
    primary: "Documentation",
    path: "/documentation/scope1/stationary-combustion",
    moduleName: "Documentation",
  },
  {
    title: "Settings",
    icon: setting,
    primary: "Settings",
    path: "/settings",
  },
];

export const socialElements = [
  {
    subData: [
      {
        path: "/social/dashboard",
        primary: "Overview",
        icon: overview,
        openAnotherSidebar: true,
        nextSidebar: "subElements",
      },
      {
        path: "/social/data",
        primary: "Data",
        icon: misreport,
      },
    ],
  },
];

export const governanceElements = [
  {
    subData: [
      {
        path: "/governance/dashboard",
        primary: "Overview",
        icon: overview,
        openAnotherSidebar: true,
        nextSidebar: "subElements",
      },
      {
        path: "/governance/data",
        primary: "Data",
        icon: misreport,
      },
    ],
  },
];

export const sidebarElements1 = [
  {
    heading: "Overview",
    path: "/dashboard",
    icon: overview,
    // moduleName: "Overview",
  },
  {
    heading: "Reports",
    collapse: true,
    icon: misreport,
    path: "/mis-report",
    moduleName: "Reports",
    subData: [
      {
        path: "/mis-report",
        primary: "MIS Reports",
        subHeading: "MIS Reports",
        icon: misreport,
        moduleName: "MIS Reports",
      },
      {
        path: "/ghg-report",
        primary: "GHG Reports",
        icon: environment,
        subHeading: "GHG Reports",
        moduleName: "GHG Reports",
      },
    ],
  },
  {
    heading: "Environment",
    collapse: true,
    icon: environment,
    moduleName: "Environment",
    subData: [
      {
        subHeading: "Overview",
        url: "/environment/dashboard",
        icon: overview,
        moduleName: "Environment | Overview",
      },
      {
        subHeading: "GHG Accounting",
        url: "/scope1/dashboard",
        subcollapse: true,
        icon: ghgicon,
        moduleName: "Environment | GHG Accounting",
        subChildren: [
          {
            path: "/scope1/dashboard",
            primary: "Scope 1",
            icon: scope1,
            moduleName: "Environment | Scope 1",
          },
          {
            path: "/scope2/dashboard",
            primary: "Scope 2",
            icon: scope2,
            moduleName: "Environment | Scope 2",
          },
          {
            path: "/scope3/dashboard",
            primary: "Scope 3",
            icon: scope3,
            moduleName: "Environment | Scope 3",
            subsubChildren: [
              {
                text: "Overview",
                icon: scopeoverview,
                path: "/scope3/dashboard",
                moduleName: "Environment | Scope 3",
              },
              {
                text: "Purchased Goods and Services",
                icon: purchasegoods,
                path: "/scope3/purchased-goods/dashboard",
                moduleName:
                  "Environment | Scope 3 | Purchased goods & services",
              },
              {
                text: "Transportation and Distribution",
                icon: transportmaster,
                path: "/scope3/transportation/dashboard",
                moduleName: "Environment | Scope 3 | Transportation",
              },

              {
                text: "Employee Commute",
                icon: purchasegoods,
                path: "/scope3/employee-commute/dashboard",
                moduleName: "Environment | Scope 3 | Employee commute",
              },

              {
                text: "Business Travel",
                icon: businesstravel,
                path: "/scope3/business-travel/dashboard",
                moduleName: "Environment | Scope 3 | Business travel",
              },
              {
                text: "Waste Generated in Operations",
                icon: wastegenerated,
                path: "/scope3/waste-generated/dashboard",
                moduleName: "Environment | Scope 3 | Waste generated",
              },
            ],
          },
          {
            path: "/scope4/renewable-energy-export/",
            primary: "Scope 4",
            icon: scope4,
            moduleName: "Environment | Scope 4",
          },
        ],
      },
      {
        subHeading: "Water Management",
        url: "/water-management/dash-board",
        icon: watermanagement,
        moduleName: "Water management",
      },
    ],
  },
  {
    heading: "Social",
    path: "/social/dashboard",
    icon: social,
    moduleName: "Social",
  },
  {
    heading: "Governance",
    path: "/governance/dashboard",
    icon: governance,
    moduleName: "Governance",
  },
  {
    heading: "Production & Revenue",
    path: "/production-revenue",
    icon: productionRevenue,
    moduleName: "Production & Revenue",
  },
  {
    heading: "ESG Reporting",
    collapse: true,
    icon: esgreporting,
    moduleName: "ESG Reporting",
    subData: [
      {
        path: "/brsr",
        primary: "BRSR",
        subHeading: "BRSR",
        icon: brsr,
        moduleName: "ESG Reporting | BRSR",
      },
      {
        path: "/gri",
        primary: "GRI",
        icon: gri,
        subHeading: "GRI",
        moduleName: "ESG Reporting | GRI",
      },
    ],
  },
  {
    heading: "Value Chain",
    collapse: true,
    icon: valuechain,
    path: "/value-chain-partner",
    moduleName: "Value Chain",
    subData: [
      {
        path: "/value-chain-partner/upstream",
        primary: "Value Chain Partners",
        subHeading: "Value Chain Partners",
        icon: valuechainpartner,
        moduleName: "Value Chain | Partner",
      },
      //   {
      //   path: "/value-chain-partner/downstream",
      //   primary: "Value Chain Partners",
      //   subHeading: "Value Chain Partners",
      //   icon: valuechainpartner,
      // },
      {
        path: "/value-chain-request",
        primary: "Request Emission Data",
        icon: valuechainrequest,
        subHeading: "Request Emission Data",
        moduleName: "Value Chain | Request",
      },
      {
        path: "/value-chain/dashboard",
        primary: "Emission Data",
        icon: valuechain,
        subHeading: "Emission Data",
        moduleName: "Value Chain | Dashboard",
      },
    ],
  },
  {
    heading: "Setup",
    collapse: true,
    icon: setup,
    moduleName: "Setup",
    subData: [
      {
        path: "/setup/masters/industrial-process",
        primary: "Masters",
        subHeading: "Masters",
        icon: masters,
        moduleName: "Setup | Masters",
      },
      // {
      //   path: "/setup/masters/scope1/product-master",
      //   primary: "Masters",
      //   subHeading: "Masters",
      //   icon: masters,
      //   moduleName: "Setup | Masters",
      // },
      {
        path: "/setup/roles-permission",
        primary: "Roles and Permissions",
        icon: rolesnpermission,
        subHeading: "Roles and Permissions",
        moduleName: "Setup | Roles & Permission",
      },
      {
        path: "/setup/facility-master",
        primary: "Facility Master",
        icon: facility,
        subHeading: "Facility Master",
        moduleName: "Setup | Facility Master",
      },
    ],
  },
  {
    heading: "ESG Questionnaire",
    path: "/questionaire",
    icon: initialQuestionare,
    moduleName: "Initial Questionnaire",
  },
  {
    heading: "Support",
    path: "/ticket",
    icon: support,
    // moduleName: "Support",
  },
  {
    heading: "FAQ",
    path: "/faq",
    icon: faq,
    // moduleName: "FAQ",
  },
  {
    heading: "Documentation",
    path: "/documentation/scope1/stationary-combustion",
    icon: documentation,
    moduleName: "Documentation",
  },
  {
    heading: "Settings",
    path: "/settings",
    icon: setting,
    // moduleName: "Settings",
  },
];

export const trialUsersidebarElements = [
  {
    heading: "Overview",
    path: "/dashboard",
    icon: overview,
    // moduleName: "Overview",
  },
  {
    heading: "Reports",
    collapse: true,
    icon: misreport,
    path: "/mis-report",
    moduleName: "Reports",
    subData: [
      {
        path: "/mis-report",
        primary: "MIS Reports",
        subHeading: "MIS Reports",
        icon: misreport,
        moduleName: "MIS Reports",
      },
      {
        path: "/ghg-report",
        primary: "GHG Reports",
        icon: environment,
        subHeading: "GHG Reports",
        moduleName: "GHG Reports",
      },
    ],
  },
  {
    heading: "Environment",
    collapse: true,
    icon: environment,
    moduleName: "Environment",
    subData: [
      {
        subHeading: "Overview",
        url: "/environment/dashboard",
        icon: overview,
        moduleName: "Environment | Overview",
      },
      {
        subHeading: "GHG Accounting",
        url: "/scope1/dashboard",
        subcollapse: true,
        icon: ghgicon,
        moduleName: "Environment | GHG Accounting",
        subChildren: [
          {
            path: "/scope1/dashboard",
            primary: "Scope 1",
            icon: scope1,
            moduleName: "Environment | Scope 1",
          },
          {
            path: "/scope2/dashboard",
            primary: "Scope 2",
            icon: scope2,
            moduleName: "Environment | Scope 2",
          },
          {
            path: "/scope3/dashboard",
            primary: "Scope 3",
            icon: scope3,
            moduleName: "Environment | Scope 3",
            subsubChildren: [
              {
                text: "Overview",
                icon: scopeoverview,
                path: "/scope3/dashboard",
                moduleName: "Environment | Scope 3",
              },
              {
                text: "Purchased Goods and Services",
                icon: purchasegoods,
                path: "/scope3/purchased-goods/dashboard",
                moduleName:
                  "Environment | Scope 3 | Purchased goods & services",
              },
              {
                text: "Transportation and Distribution",
                icon: transportmaster,
                path: "/scope3/transportation/dashboard",
                moduleName: "Environment | Scope 3 | Transportation",
              },

              {
                text: "Employee Commute",
                icon: purchasegoods,
                path: "/scope3/employee-commute/dashboard",
                moduleName: "Environment | Scope 3 | Employee commute",
              },

              {
                text: "Business Travel",
                icon: businesstravel,
                path: "/scope3/business-travel/dashboard",
                moduleName: "Environment | Scope 3 | Business travel",
              },
              {
                text: "Waste Generated in Operations",
                icon: wastegenerated,
                path: "/scope3/waste-generated/dashboard",
                moduleName: "Environment | Scope 3 | Waste generated",
              },
            ],
          },
          {
            path: "/scope4/renewable-energy-export/",
            primary: "Scope 4",
            icon: scope4,
            moduleName: "Environment | Scope 4",
          },
        ],
      },
      {
        subHeading: "Water Management",
        url: "/water-management/dash-board",
        icon: watermanagement,
        moduleName: "Water management",
      },
    ],
  },
  {
    heading: "Social",
    path: "/social/dashboard",
    icon: social,
    moduleName: "Social",
  },
  {
    heading: "Governance",
    path: "/governance/dashboard",
    icon: governance,
    moduleName: "Governance",
  },
  {
    heading: "Production & Revenue",
    path: "/production-revenue",
    icon: productionRevenue,
    moduleName: "Production & Revenue",
  },
  {
    heading: "ESG Reporting",
    collapse: true,
    icon: esgreporting,
    moduleName: "ESG Reporting",
    subData: [
      {
        path: "/brsr",
        primary: "BRSR",
        subHeading: "BRSR",
        icon: brsr,
        moduleName: "ESG Reporting | BRSR",
      },
      {
        path: "/gri",
        primary: "GRI",
        icon: gri,
        subHeading: "GRI",
        moduleName: "ESG Reporting | GRI",
      },
    ],
  },
  {
    heading: "Value Chain",
    collapse: true,
    icon: valuechain,
    path: "/value-chain-partner",
    moduleName: "Value Chain",
    subData: [
      {
        path: "/value-chain-partner/upstream",
        primary: "Value Chain Partners",
        subHeading: "Value Chain Partners",
        icon: valuechainpartner,
        moduleName: "Value Chain | Partner",
      },
      //   {
      //   path: "/value-chain-partner/downstream",
      //   primary: "Value Chain Partners",
      //   subHeading: "Value Chain Partners",
      //   icon: valuechainpartner,
      // },
      {
        path: "/value-chain-request",
        primary: "Request Emission Data",
        icon: valuechainrequest,
        subHeading: "Request Emission Data",
        moduleName: "Value Chain | Request",
      },
      {
        path: "/value-chain/dashboard",
        primary: "Emission Data",
        icon: valuechain,
        subHeading: "Emission Data",
        moduleName: "Value Chain | Dashboard",
      },
    ],
  },
  {
    heading: "Setup",
    collapse: true,
    icon: setup,
    moduleName: "Setup",
    subData: [
      {
        path: "/setup/masters/industrial-process",
        primary: "Masters",
        subHeading: "Masters",
        icon: masters,
        moduleName: "Setup | Masters",
      },

      {
        path: "/setup/roles-permission",
        primary: "Roles and Permissions",
        icon: rolesnpermission,
        subHeading: "Roles and Permissions",
        moduleName: "Setup | Roles & Permission",
      },
      {
        path: "/setup/facility-master",
        primary: "Facility Master",
        icon: facility,
        subHeading: "Facility Master",
        moduleName: "Setup | Facility Master",
      },
    ],
  },
  {
    heading: "ESG Questionnaire",
    path: "/questionaire",
    icon: initialQuestionare,
    moduleName: "Initial Questionnaire",
  },
  {
    heading: "Support",
    path: "/ticket",
    icon: support,
    // moduleName: "Support",
  },
  {
    heading: "FAQ",
    path: "/faq",
    icon: faq,
    // moduleName: "FAQ",
  },
  {
    heading: "Documentation",
    path: "/documentation/scope1/stationary-combustion",
    icon: documentation,
    moduleName: "Documentation",
  },
  {
    heading: "Settings",
    path: "/settings",
    icon: setting,
    // moduleName: "Settings",
  },
];

export const sidebarElementsFacility = [
  {
    heading: "Overview",
    path: "/dashboard",
    icon: overview,
    // moduleName: "Overview",
  },
  {
    heading: "Environment",
    collapse: true,
    icon: environment,
    moduleName: "Environment",
    subData: [
      {
        subHeading: "Overview",
        url: "/environment/dashboard",
        icon: overview,
        moduleName: "Environment | Overview",
      },
      {
        subHeading: "GHG Accounting",
        url: "/scope1/dashboard",
        subcollapse: true,
        icon: ghgicon,
        moduleName: "Environment | GHG Accounting",
        subChildren: [
          {
            path: "/scope1/dashboard",
            primary: "Scope 1",
            icon: scope1,
            moduleName: "Environment | Scope 1",
          },
          {
            path: "/scope2/dashboard",
            primary: "Scope 2",
            icon: scope2,
            moduleName: "Environment | Scope 2",
          },
          {
            path: "/scope3/dashboard",
            primary: "Scope 3",
            icon: scope3,
            moduleName: "Environment | Scope 3",
            subsubChildren: [
              {
                text: "Overview",
                icon: scopeoverview,
                path: "/scope3/dashboard",
                moduleName: "Environment | Scope 3 | Overview",
              },
              {
                text: "Purchased Goods and Services",
                icon: purchasegoods,
                path: "/scope3/purchased-goods/dashboard",
                moduleName:
                  "Environment | Scope 3 | Purchased goods & services",
              },
              {
                text: "Transportation and Distribution",
                icon: transportmaster,
                path: "/scope3/transportation/dashboard",
                moduleName: "Environment | Scope 3 | Transportation",
              },

              {
                text: "Employee Commute",
                icon: purchasegoods,
                path: "/scope3/employee-commute/dashboard",
                moduleName: "Environment | Scope 3 | Employee commute",
              },

              {
                text: "Business Travel",
                icon: businesstravel,
                path: "/scope3/business-travel/dashboard",
                moduleName: "Environment | Scope 3 | Business travel",
              },
              {
                text: "Waste Generated in Operations",
                icon: wastegenerated,
                path: "/scope3/waste-generated/dashboard",
                moduleName: "Environment | Scope 3 | Waste generated",
              },
            ],
          },
          {
            path: "/scope4/renewable-energy-export",
            primary: "Scope 4",
            icon: scope4,
            moduleName: "Environment | Scope 4",
          },
        ],
      },
      {
        subHeading: "Water Management",
        url: "/water-management/dash-board",
        icon: watermanagement,
        moduleName: "Water management",
      },
    ],
  },
  {
    heading: "Production & Revenue",
    path: "/production-revenue",
    icon: productionRevenue,
    moduleName: "Production & Revenue",
  },
  {
    heading: "Value Chain",
    collapse: true,
    icon: valuechain,
    path: "/value-chain",
    moduleName: "Value Chain",
    subData: [
      {
        path: "/value-chain-partner/upstream",
        primary: "Value Chain Partners",
        subHeading: "Value Chain Partners",
        icon: valuechainpartner,
        moduleName: "Value Chain | Partner",
      },
      {
        path: "/value-chain-request",
        primary: "Request Emission Data",
        icon: valuechainrequest,
        subHeading: "Request Emission Data",
        moduleName: "Value Chain | Request",
      },
      {
        path: "/value-chain/dashboard",
        primary: "Emission Data",
        icon: valuechain,
        subHeading: "Emission Data",
        moduleName: "Value Chain | Dashboard",
      },
    ],
  },
  {
    heading: "Setup",
    collapse: true,
    icon: setup,
    moduleName: "Setup",
    subData: [
      {
        path: "/setup/masters/industrial-process",
        primary: "Masters",
        subHeading: "Masters",
        icon: masters,
        moduleName: "Setup | Masters",
      },
      {
        path: "/setup/roles-permission",
        primary: "Roles and Permissions",
        icon: rolesnpermission,
        subHeading: "Roles and Permissions",
        moduleName: "Setup | Roles & Permission",
      },
    ],
  },
  {
    heading: "Support",
    path: "/ticket",
    icon: support,
    // moduleName: "Support",
  },
  {
    heading: "FAQ",
    path: "/faq",
    icon: faq,
    // moduleName: "FAQ",
  },
  {
    heading: "Approval",
    path: "/approval/scope1/stationary-combustion",
    icon: approval,
    moduleName: "Approval",
  },
  {
    heading: "Documentation",
    path: "/documentation/scope1/stationary-combustion",
    icon: documentation,
    moduleName: "Documentation",
  },
  {
    heading: "Settings",
    path: "/settings",
    icon: setting,
    // moduleName: "Settings",
  },
];

export const sidebarElementsGroupAdmin = [
  {
    heading: "Overview",
    path: "/dashboard",
    icon: overview,
  },
  {
    heading: "Reports",
    collapse: true,
    icon: misreport,
    subData: [
      {
        path: "/mis-report",
        primary: "MIS Reports",
        subHeading: "MIS Reports",
        icon: misreport,
        moduleName: "MIS Reports",
      },
      {
        path: "/ghg-report",
        primary: "GHG Reports",
        icon: environment,
        subHeading: "GHG Reports",
        moduleName: "GHG Reports",
      },
    ],
  },
  {
    heading: "Environment",
    collapse: true,
    icon: environment,
    subData: [
      {
        subHeading: "GHG Accounting",
        // url: "/scope1/dashboard",
        subcollapse: true,
        icon: ghgicon,
        subChildren: [
          {
            path: "/scope1/dashboard",
            primary: "Scope 1",
            icon: scope1,
            moduleName: "Environment | Scope 1 ",
          },
          {
            path: "/scope2/dashboard",
            primary: "Scope 2",
            icon: scope2,
            moduleName: "Environment | Scope 2 ",
          },
          {
            // path: "/scope3/dashboard",
            subHeading: "Scope 3",
            collapse: true,
            icon: scope3,
            subsubChildren: [
              {
                text: "Overview",
                icon: scopeoverview,
                path: "/scope3/dashboard",
                moduleName: "Environment | Scope 3 | Overview",
              },
              {
                text: "Purchased Goods and Services",
                icon: purchasegoods,
                path: "/scope3/purchased-goods/dashboard",
                moduleName:
                  "Environment | Scope 3 | Purchased goods & services",
              },
              {
                text: "Transportation and Distribution",
                icon: transportmaster,
                path: "/scope3/transportation/dashboard",
                moduleName: "Environment | Scope 3 | Transportation",
              },

              {
                text: "Employee Commute",
                icon: purchasegoods,
                path: "/scope3/employee-commute/dashboard",
                moduleName: "Environment | Scope 3 | Employee commute",
              },
              {
                text: "Business Travel",
                icon: businesstravel,
                path: "/scope3/business-travel/dashboard",
                moduleName: "Environment | Scope 3 | Business travel",
              },
              // {
              //   text: "Upstream Leased Assets",
              //   icon: upstreamleasedassets,
              //   path: "/scope3/upstream-leased-assets",
              //   moduleName: "Environment | Scope 3 | Upstream Leased Assets",
              // },
              // {
              //   text: "Upstream Leased Assets",
              //   icon: upstreamleasedassets,
              //   path: "/scope3/upstream-leased-assets",
              //   moduleName: "Environment | Scope 3 | Upstream Leased Assets",
              // },
              {
                text: "Waste Generated in Operations",
                icon: wastegenerated,
                path: "/scope3/waste-generated/dashboard",
                moduleName: "Environment | Scope 3 | Waste generated",
              },
            ],
          },
        ],
      },
      {
        subHeading: "Water Management",
        url: "/water-management/dash-board",
        icon: watermanagement,
        moduleName: "Water management",
      },
    ],
  },
  {
    heading: "Social",
    path: "/social/dashboard",
    icon: social,
    moduleName: "Social",
  },
  {
    heading: "Governance",
    path: "/governance/dashboard",
    icon: governance,
    moduleName: "Governance",
  },
  {
    heading: "Setup",
    collapse: true,
    icon: setup,
    subData: [
      // {
      //   path: "/setup/masters/scope1/industrial-process",
      //   primary: "Masters",
      //   subHeading: "Masters",
      //   icon: masters,
      // },
      {
        path: "/setup/roles-permission",
        primary: "Roles and Permissions",
        icon: rolesnpermission,
        subHeading: "Roles and Permissions",
        moduleName: "Setup | Roles and Permissions",
      },
      // {
      //   path: "/setup/facility-master",
      //   primary: "Facility Master",
      //   icon: facility,
      //   subHeading: "Facility Master",
      //   moduleName: "Setup | Facility Master",
      // },
    ],
  },
  {
    heading: "Support",
    path: "/ticket",
    icon: support,
    moduleName: "Support",
  },
  {
    heading: "FAQ",
    path: "/faq",
    icon: faq,
    moduleName: "FAQ",
  },
  {
    heading: "Settings",
    path: "/settings",
    icon: setting,
    moduleName: "Settings",
  },
];

export const countries = [
  { code: "AD", label: "Andorra", phone: "376" },
  {
    code: "AE",
    label: "United Arab Emirates",
    phone: "971",
  },
  { code: "AF", label: "Afghanistan", phone: "93" },
  {
    code: "AG",
    label: "Antigua and Barbuda",
    phone: "1-268",
  },
  { code: "AI", label: "Anguilla", phone: "1-264" },
  { code: "AL", label: "Albania", phone: "355" },
  { code: "AM", label: "Armenia", phone: "374" },
  { code: "AO", label: "Angola", phone: "244" },
  { code: "AQ", label: "Antarctica", phone: "672" },
  { code: "AR", label: "Argentina", phone: "54" },
  { code: "AS", label: "American Samoa", phone: "1-684" },
  { code: "AT", label: "Austria", phone: "43" },
  {
    code: "AU",
    label: "Australia",
    phone: "61",
    suggested: true,
  },
  { code: "AW", label: "Aruba", phone: "297" },
  { code: "AX", label: "Alland Islands", phone: "358" },
  { code: "AZ", label: "Azerbaijan", phone: "994" },
  {
    code: "BA",
    label: "Bosnia and Herzegovina",
    phone: "387",
  },
  { code: "BB", label: "Barbados", phone: "1-246" },
  { code: "BD", label: "Bangladesh", phone: "880" },
  { code: "BE", label: "Belgium", phone: "32" },
  { code: "BF", label: "Burkina Faso", phone: "226" },
  { code: "BG", label: "Bulgaria", phone: "359" },
  { code: "BH", label: "Bahrain", phone: "973" },
  { code: "BI", label: "Burundi", phone: "257" },
  { code: "BJ", label: "Benin", phone: "229" },
  { code: "BL", label: "Saint Barthelemy", phone: "590" },
  { code: "BM", label: "Bermuda", phone: "1-441" },
  { code: "BN", label: "Brunei Darussalam", phone: "673" },
  { code: "BO", label: "Bolivia", phone: "591" },
  { code: "BR", label: "Brazil", phone: "55" },
  { code: "BS", label: "Bahamas", phone: "1-242" },
  { code: "BT", label: "Bhutan", phone: "975" },
  { code: "BV", label: "Bouvet Island", phone: "47" },
  { code: "BW", label: "Botswana", phone: "267" },
  { code: "BY", label: "Belarus", phone: "375" },
  { code: "BZ", label: "Belize", phone: "501" },
  {
    code: "CA",
    label: "Canada",
    phone: "1",
    suggested: true,
  },
  {
    code: "CC",
    label: "Cocos (Keeling) Islands",
    phone: "61",
  },
  {
    code: "CD",
    label: "Congo, Democratic Republic of the",
    phone: "243",
  },
  {
    code: "CF",
    label: "Central African Republic",
    phone: "236",
  },
  {
    code: "CG",
    label: "Congo, Republic of the",
    phone: "242",
  },
  { code: "CH", label: "Switzerland", phone: "41" },
  { code: "CI", label: "Cote d'Ivoire", phone: "225" },
  { code: "CK", label: "Cook Islands", phone: "682" },
  { code: "CL", label: "Chile", phone: "56" },
  { code: "CM", label: "Cameroon", phone: "237" },
  { code: "CN", label: "China", phone: "86" },
  { code: "CO", label: "Colombia", phone: "57" },
  { code: "CR", label: "Costa Rica", phone: "506" },
  { code: "CU", label: "Cuba", phone: "53" },
  { code: "CV", label: "Cape Verde", phone: "238" },
  { code: "CW", label: "Curacao", phone: "599" },
  { code: "CX", label: "Christmas Island", phone: "61" },
  { code: "CY", label: "Cyprus", phone: "357" },
  { code: "CZ", label: "Czech Republic", phone: "420" },
  {
    code: "DE",
    label: "Germany",
    phone: "49",
    suggested: true,
  },
  { code: "DJ", label: "Djibouti", phone: "253" },
  { code: "DK", label: "Denmark", phone: "45" },
  { code: "DM", label: "Dominica", phone: "1-767" },
  {
    code: "DO",
    label: "Dominican Republic",
    phone: "1-809",
  },
  { code: "DZ", label: "Algeria", phone: "213" },
  { code: "EC", label: "Ecuador", phone: "593" },
  { code: "EE", label: "Estonia", phone: "372" },
  { code: "EG", label: "Egypt", phone: "20" },
  { code: "EH", label: "Western Sahara", phone: "212" },
  { code: "ER", label: "Eritrea", phone: "291" },
  { code: "ES", label: "Spain", phone: "34" },
  { code: "ET", label: "Ethiopia", phone: "251" },
  { code: "FI", label: "Finland", phone: "358" },
  { code: "FJ", label: "Fiji", phone: "679" },
  {
    code: "FK",
    label: "Falkland Islands (Malvinas)",
    phone: "500",
  },
  {
    code: "FM",
    label: "Micronesia, Federated States of",
    phone: "691",
  },
  { code: "FO", label: "Faroe Islands", phone: "298" },
  {
    code: "FR",
    label: "France",
    phone: "33",
    suggested: true,
  },
  { code: "GA", label: "Gabon", phone: "241" },
  { code: "GB", label: "United Kingdom", phone: "44" },
  { code: "GD", label: "Grenada", phone: "1-473" },
  { code: "GE", label: "Georgia", phone: "995" },
  { code: "GF", label: "French Guiana", phone: "594" },
  { code: "GG", label: "Guernsey", phone: "44" },
  { code: "GH", label: "Ghana", phone: "233" },
  { code: "GI", label: "Gibraltar", phone: "350" },
  { code: "GL", label: "Greenland", phone: "299" },
  { code: "GM", label: "Gambia", phone: "220" },
  { code: "GN", label: "Guinea", phone: "224" },
  { code: "GP", label: "Guadeloupe", phone: "590" },
  { code: "GQ", label: "Equatorial Guinea", phone: "240" },
  { code: "GR", label: "Greece", phone: "30" },
  {
    code: "GS",
    label: "South Georgia and the South Sandwich Islands",
    phone: "500",
  },
  { code: "GT", label: "Guatemala", phone: "502" },
  { code: "GU", label: "Guam", phone: "1-671" },
  { code: "GW", label: "Guinea-Bissau", phone: "245" },
  { code: "GY", label: "Guyana", phone: "592" },
  { code: "HK", label: "Hong Kong", phone: "852" },
  {
    code: "HM",
    label: "Heard Island and McDonald Islands",
    phone: "672",
  },
  { code: "HN", label: "Honduras", phone: "504" },
  { code: "HR", label: "Croatia", phone: "385" },
  { code: "HT", label: "Haiti", phone: "509" },
  { code: "HU", label: "Hungary", phone: "36" },
  { code: "ID", label: "Indonesia", phone: "62" },
  { code: "IE", label: "Ireland", phone: "353" },
  { code: "IL", label: "Israel", phone: "972" },
  { code: "IM", label: "Isle of Man", phone: "44" },
  { code: "IN", label: "India", phone: "91" },
  {
    code: "IO",
    label: "British Indian Ocean Territory",
    phone: "246",
  },
  { code: "IQ", label: "Iraq", phone: "964" },
  {
    code: "IR",
    label: "Iran, Islamic Republic of",
    phone: "98",
  },
  { code: "IS", label: "Iceland", phone: "354" },
  { code: "IT", label: "Italy", phone: "39" },
  { code: "JE", label: "Jersey", phone: "44" },
  { code: "JM", label: "Jamaica", phone: "1-876" },
  { code: "JO", label: "Jordan", phone: "962" },
  {
    code: "JP",
    label: "Japan",
    phone: "81",
    suggested: true,
  },
  { code: "KE", label: "Kenya", phone: "254" },
  { code: "KG", label: "Kyrgyzstan", phone: "996" },
  { code: "KH", label: "Cambodia", phone: "855" },
  { code: "KI", label: "Kiribati", phone: "686" },
  { code: "KM", label: "Comoros", phone: "269" },
  {
    code: "KN",
    label: "Saint Kitts and Nevis",
    phone: "1-869",
  },
  {
    code: "KP",
    label: "Korea, Democratic People's Republic of",
    phone: "850",
  },
  { code: "KR", label: "Korea, Republic of", phone: "82" },
  { code: "KW", label: "Kuwait", phone: "965" },
  { code: "KY", label: "Cayman Islands", phone: "1-345" },
  { code: "KZ", label: "Kazakhstan", phone: "7" },
  {
    code: "LA",
    label: "Lao People's Democratic Republic",
    phone: "856",
  },
  { code: "LB", label: "Lebanon", phone: "961" },
  { code: "LC", label: "Saint Lucia", phone: "1-758" },
  { code: "LI", label: "Liechtenstein", phone: "423" },
  { code: "LK", label: "Sri Lanka", phone: "94" },
  { code: "LR", label: "Liberia", phone: "231" },
  { code: "LS", label: "Lesotho", phone: "266" },
  { code: "LT", label: "Lithuania", phone: "370" },
  { code: "LU", label: "Luxembourg", phone: "352" },
  { code: "LV", label: "Latvia", phone: "371" },
  { code: "LY", label: "Libya", phone: "218" },
  { code: "MA", label: "Morocco", phone: "212" },
  { code: "MC", label: "Monaco", phone: "377" },
  {
    code: "MD",
    label: "Moldova, Republic of",
    phone: "373",
  },
  { code: "ME", label: "Montenegro", phone: "382" },
  {
    code: "MF",
    label: "Saint Martin (French part)",
    phone: "590",
  },
  { code: "MG", label: "Madagascar", phone: "261" },
  { code: "MH", label: "Marshall Islands", phone: "692" },
  {
    code: "MK",
    label: "Macedonia, the Former Yugoslav Republic of",
    phone: "389",
  },
  { code: "ML", label: "Mali", phone: "223" },
  { code: "MM", label: "Myanmar", phone: "95" },
  { code: "MN", label: "Mongolia", phone: "976" },
  { code: "MO", label: "Macao", phone: "853" },
  {
    code: "MP",
    label: "Northern Mariana Islands",
    phone: "1-670",
  },
  { code: "MQ", label: "Martinique", phone: "596" },
  { code: "MR", label: "Mauritania", phone: "222" },
  { code: "MS", label: "Montserrat", phone: "1-664" },
  { code: "MT", label: "Malta", phone: "356" },
  { code: "MU", label: "Mauritius", phone: "230" },
  { code: "MV", label: "Maldives", phone: "960" },
  { code: "MW", label: "Malawi", phone: "265" },
  { code: "MX", label: "Mexico", phone: "52" },
  { code: "MY", label: "Malaysia", phone: "60" },
  { code: "MZ", label: "Mozambique", phone: "258" },
  { code: "NA", label: "Namibia", phone: "264" },
  { code: "NC", label: "New Caledonia", phone: "687" },
  { code: "NE", label: "Niger", phone: "227" },
  { code: "NF", label: "Norfolk Island", phone: "672" },
  { code: "NG", label: "Nigeria", phone: "234" },
  { code: "NI", label: "Nicaragua", phone: "505" },
  { code: "NL", label: "Netherlands", phone: "31" },
  { code: "NO", label: "Norway", phone: "47" },
  { code: "NP", label: "Nepal", phone: "977" },
  { code: "NR", label: "Nauru", phone: "674" },
  { code: "NU", label: "Niue", phone: "683" },
  { code: "NZ", label: "New Zealand", phone: "64" },
  { code: "OM", label: "Oman", phone: "968" },
  { code: "PA", label: "Panama", phone: "507" },
  { code: "PE", label: "Peru", phone: "51" },
  { code: "PF", label: "French Polynesia", phone: "689" },
  { code: "PG", label: "Papua New Guinea", phone: "675" },
  { code: "PH", label: "Philippines", phone: "63" },
  { code: "PK", label: "Pakistan", phone: "92" },
  { code: "PL", label: "Poland", phone: "48" },
  {
    code: "PM",
    label: "Saint Pierre and Miquelon",
    phone: "508",
  },
  { code: "PN", label: "Pitcairn", phone: "870" },
  { code: "PR", label: "Puerto Rico", phone: "1" },
  {
    code: "PS",
    label: "Palestine, State of",
    phone: "970",
  },
  { code: "PT", label: "Portugal", phone: "351" },
  { code: "PW", label: "Palau", phone: "680" },
  { code: "PY", label: "Paraguay", phone: "595" },
  { code: "QA", label: "Qatar", phone: "974" },
  { code: "RE", label: "Reunion", phone: "262" },
  { code: "RO", label: "Romania", phone: "40" },
  { code: "RS", label: "Serbia", phone: "381" },
  { code: "RU", label: "Russian Federation", phone: "7" },
  { code: "RW", label: "Rwanda", phone: "250" },
  { code: "SA", label: "Saudi Arabia", phone: "966" },
  { code: "SB", label: "Solomon Islands", phone: "677" },
  { code: "SC", label: "Seychelles", phone: "248" },
  { code: "SD", label: "Sudan", phone: "249" },
  { code: "SE", label: "Sweden", phone: "46" },
  { code: "SG", label: "Singapore", phone: "65" },
  { code: "SH", label: "Saint Helena", phone: "290" },
  { code: "SI", label: "Slovenia", phone: "386" },
  {
    code: "SJ",
    label: "Svalbard and Jan Mayen",
    phone: "47",
  },
  { code: "SK", label: "Slovakia", phone: "421" },
  { code: "SL", label: "Sierra Leone", phone: "232" },
  { code: "SM", label: "San Marino", phone: "378" },
  { code: "SN", label: "Senegal", phone: "221" },
  { code: "SO", label: "Somalia", phone: "252" },
  { code: "SR", label: "Suriname", phone: "597" },
  { code: "SS", label: "South Sudan", phone: "211" },
  {
    code: "ST",
    label: "Sao Tome and Principe",
    phone: "239",
  },
  { code: "SV", label: "El Salvador", phone: "503" },
  {
    code: "SX",
    label: "Sint Maarten (Dutch part)",
    phone: "1-721",
  },
  {
    code: "SY",
    label: "Syrian Arab Republic",
    phone: "963",
  },
  { code: "SZ", label: "Swaziland", phone: "268" },
  {
    code: "TC",
    label: "Turks and Caicos Islands",
    phone: "1-649",
  },
  { code: "TD", label: "Chad", phone: "235" },
  {
    code: "TF",
    label: "French Southern Territories",
    phone: "262",
  },
  { code: "TG", label: "Togo", phone: "228" },
  { code: "TH", label: "Thailand", phone: "66" },
  { code: "TJ", label: "Tajikistan", phone: "992" },
  { code: "TK", label: "Tokelau", phone: "690" },
  { code: "TL", label: "Timor-Leste", phone: "670" },
  { code: "TM", label: "Turkmenistan", phone: "993" },
  { code: "TN", label: "Tunisia", phone: "216" },
  { code: "TO", label: "Tonga", phone: "676" },
  { code: "TR", label: "Turkey", phone: "90" },
  {
    code: "TT",
    label: "Trinidad and Tobago",
    phone: "1-868",
  },
  { code: "TV", label: "Tuvalu", phone: "688" },
  {
    code: "TW",
    label: "Taiwan",
    phone: "886",
  },
  {
    code: "TZ",
    label: "United Republic of Tanzania",
    phone: "255",
  },
  { code: "UA", label: "Ukraine", phone: "380" },
  { code: "UG", label: "Uganda", phone: "256" },
  {
    code: "US",
    label: "United States",
    phone: "1",
    suggested: true,
  },
  { code: "UY", label: "Uruguay", phone: "598" },
  { code: "UZ", label: "Uzbekistan", phone: "998" },
  {
    code: "VA",
    label: "Holy See (Vatican City State)",
    phone: "379",
  },
  {
    code: "VC",
    label: "Saint Vincent and the Grenadines",
    phone: "1-784",
  },
  { code: "VE", label: "Venezuela", phone: "58" },
  {
    code: "VG",
    label: "British Virgin Islands",
    phone: "1-284",
  },
  {
    code: "VI",
    label: "US Virgin Islands",
    phone: "1-340",
  },
  { code: "VN", label: "Vietnam", phone: "84" },
  { code: "VU", label: "Vanuatu", phone: "678" },
  { code: "WF", label: "Wallis and Futuna", phone: "681" },
  { code: "WS", label: "Samoa", phone: "685" },
  { code: "XK", label: "Kosovo", phone: "383" },
  { code: "YE", label: "Yemen", phone: "967" },
  { code: "YT", label: "Mayotte", phone: "262" },
  { code: "ZA", label: "South Africa", phone: "27" },
  { code: "ZM", label: "Zambia", phone: "260" },
  { code: "ZW", label: "Zimbabwe", phone: "263" },
];

export const mastersSidebarElements = [
  {
    text: "Industrial Process Master",
    icon: industryprocess,
    path: "/setup/masters/industrial-process",
  },
  {
    text: "Scope 1",
    icon: scope1,
    path: "",
    children: [
      {
        text: "Product Master",
        icon: machinemaster,
        path: "/setup/masters/product-master",
      },
      {
        text: "Industrial Equipment Master",
        icon: industryequipment,
        path: "/setup/masters/scope1/industrial-equipment",
      },
      {
        text: "Logistics Vendor Master",
        icon: vehiclemaster,
        path: "/setup/masters/scope1/logistics-vendor-master",
      },
      {
        text: "Vehicle Master",
        icon: vehiclemaster,
        path: "/setup/masters/scope1/vehicle-master",
      },
      {
        text: "Machinery Master",
        icon: machinemaster,
        path: "/setup/masters/scope1/machinery-master",
      },
      // {
      //   text: "Product Master",
      //   icon: machinemaster,
      //   path: "/setup/masters/scope1/product-master",
      // },
    ],
  },
  {
    text: "Scope 2",
    icon: scope2,
    path: "",
    children: [
      {
        text: "Electricity Master",
        icon: electricitymaster,
        path: "/setup/masters/scope2/electricity-master",
        subchildren: [
          {
            text: "Equipment Master",
            icon: StarBorder,
            path: "/setup/masters/scope2/electricity-master/equipment-master",
          },
          {
            text: "Vendor Master",
            icon: StarBorder,
            path: "/setup/masters/scope2/electricity-master/vendor-master",
          },
        ],
      },
      {
        text: "Heating and Cooling Master",
        icon: heatmaster,
        path: "/setup/masters/scope2/heat-master",
        subchildren: [
          {
            text: "Equipment Master",
            icon: StarBorder,
            path: "/setup/masters/scope2/heat-master/equipment-master",
          },
          {
            text: "Vendor Master",
            icon: StarBorder,
            path: "/setup/masters/scope2/heat-master/vendor-master",
          },
        ],
      },
      {
        text: "Steam Master",
        icon: steammaster,
        path: "/setup/masters/scope2/steam-master",
        subchildren: [
          {
            text: "Equipment Master",
            icon: StarBorder,
            path: "/setup/masters/scope2/steam-master/equipment-master",
          },
          {
            text: "Vendor Master",
            icon: StarBorder,
            path: "/setup/masters/scope2/steam-master/vendor-master",
          },
        ],
      },
    ],
  },
  {
    text: "Scope 3",
    icon: scope3,
    path: "",
    children: [
      {
        text: "Waste Generated in Operations",
        icon: watermaster,
        path: "/setup/masters/scope3/waste-generated",
      },
      {
        text: "Purchased Goods and Services",
        icon: purchasemaster,
        path: "/setup/masters/scope3/purchased-goods",
      },
      // {
      //   text: "Leased Assets",
      //   icon: purchasemaster,
      //   path: "/setup/masters/scope3/leased-assets",
      // },
      // {
      //   text: "Franchise Master",
      //   icon: purchasemaster,
      //   path: "/setup/masters/scope3/franchise-master",
      // },
      // {
      //   text: "Investment Master",
      //   icon: purchasemaster,
      //   path: "/setup/masters/scope3/investment-master",
      // },
      {
        text: "Transportation and Distribution",
        icon: transportmaster,
        path: "/setup/masters/scope3/transportation-distribution",
        subchildren: [
          {
            text: "Logisitics Vendor Master",
            icon: StarBorder,
            path: "/setup/masters/scope3/transportation-distribution/logistics-vendor-master",
          },
          {
            text: "Vehicle Master",
            icon: StarBorder,
            path: "/setup/masters/scope3/transportation-distribution/vehicle-master",
          },
          {
            text: "Driver Master",
            icon: StarBorder,
            path: "/setup/masters/scope3/transportation-distribution/driver-master",
          },
        ],
      },
    ],
  },
];

export const typeofemissions = [
  "Carbon dioxide ; CO2",
  "Methane – non-fossil ; CH4",
  "Methane – fossil ; CH4",
  "Nitrous oxide ; N2O",
  "Nitrogen trifluoride ; NF3",
  "Sulfur hexafluoride ; SF6",
  "HFC-23 ; CHF3",
  "HFC-32 ; CH2F2",
  "HFC-41 ; CH3F",
  "HFC-125 ; CHF2CF3",
  "HFC-134 ; CHF2CHF2",
  "HFC-134a ; CH2FCF3",
  "HFC-143 ; CH2FCHF2",
  "HFC-143a ; CH3CF3",
  "HFC-152 ; CH2FCH2F",
  "HFC-152a ; CH3CHF2",
  "HFC-161 ; CH3CH2F",
  "HFC-227ca ; CF3CF2CHF2",
  "HFC-227ea ; CF3CHFCF3",
  "HFC-236cb ; CH2FCF2CF3",
  "HFC-236ea ; CHF2CHFCF3",
  "HFC-236fa ; CF3CH2CF3",
  "HFC-245ca ; CH2FCF2CHF2",
  "HFC-245cb ; CF3CF2CH3",
  "HFC-245ea ; CHF2CHFCHF2",
  "HFC-245eb ; CH2FCHFCF3",
  "HFC-245fa ; CHF2CH2CF3",
  "HFC-263fb ; CH3CH2CF3",
  "HFC-272ca ; CH3CF2CH3",
  "HFC-329p ; CHF2CF2CF2CF3",
  "HFC-365mfc ; CH3CF2CH2CF3",
  "HFC-43-10mee ; CF3CHFCHFCF2CF3",
  "HFO-1123 ; CHF=CF2",
  "HFO-1132a a ; CH2=CF2",
  "HFO-1141 a ; CH2=CHF",
  "HFO-1225ye(Z) a ; (Z)-CF3CF=CHF",
  "HFO-1225ye(E) a ; (E)-CF3CF=CHF",
  "HFO-1234ze(Z) a ; (Z)-CF3CH=CHF",
  "HFO-1234ze(E) a ; (E)-CF3CH=CHF",
  "HFO-1234yf a ; CF3CF=CH2",
  "HFO-1336mzz(E) ; (E)-CF3CH=CHCF3",
  "HFO-1336mzz(Z) ; (Z)-CF3CH=CHCF3",
  "HFO-1243zf ; CF3CH=CH2",
  "HFO-1345zfc a ; CF3CF2CH=CH2",
  "3,3,4,4,5,5,6,6,6-nonafluorohex-1ene ; n-C4F9CH=CH2",
  "3,3,4,4,5,5,6,6,7,7,8,8,8tridecafluorooct-1-ene ; n-C6F13CH=CH2",
  "3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,10heptadecafluorodec-1-ene ; n-C8F17CH=CH2",
  "3,3,3-trifluoro-2-(trifluoromethyl) prop-1-ene ; (CF3)2C=CH2",
  "1,1,2,2,3,3-hexafluorocyclopentane ; cyc (-CF2CF2CF2CH2CH2-)",
  "1,1,2,2,3,3,4-heptafluorocyclopentane ; cyc (-CF2CF2CF2CHFCH2-)",
  "1,3,3,4,4,5,5-heptafluorocyclopentene ; cyc (-CF2CF2CF2CF=CH-)",
  "(4s,5s)-1,1,2,2,3,3,4,5octafluorocyclopentane ; trans-cyc (-CF2CF2CF2CHFCHF-)",
  "HFO-1438ezy(E) ; (E)-(CF3)2CFCH=CHF",
  "HFO-1447fz ; CF3(CF2)2CH=CH2",
  "1,3,3,4,4-pentafluorocyclobutene ; cyc (-CH=CFCF2CF2-)",
  "3,3,4,4-tetrafluorocyclobutene ; cyc (-CH=CHCF2CF2-)",
  "PFC-14 ; CF4",
  "PFC-116 ; C2F6",
  "PFC-218 ; C3F8",
  "PFC-c216 ; c-C3F6",
  "PFC-C-318 (PFC-318) b ; cyc (-CF2CF2CF2CF2-)",
  "PFC-31-10 c ; n-C4F10",
  "PFC-41-12 c ; n-C5F12",
  "PFC-51-14 c ; n-C6F14",
  "PFC-61-16 ; n-C7F16",
  "PFC-71-18 ; n-C8F18",
  "PFC-91-18 c ; C10F18",
  "PFC-1114 ; CF2=CF2",
  "PFC-1216 ; CF3CF=CF2",
  "Pentadecafluorotriethylamine ; N(C2F5)3",
  "Perfluorotripropylamine ; N(CF2CF2CF3)3",
  "Heptacosafluorotributylamine ; N(CF2CF2CF2CF3)3",
  "Perfluorotripentylamine ; N(CF2CF2CF2CF2CF3)3",
  "Heptafluoroisobutyronitrile ; (CF3)2CFCN",
  "Trifluoromethylsulfur pentafluoride ; SF5CF3",
  "Sulfuryl fluoride ; SO2F2",
  "Hexafluoro-cyclobutene ; cyc (-CF=CFCF2CF2-)",
  "Octafluoro-cyclopentene (Perfluorocyclopentene) ; cyc (-CF=CFCF2CF2CF2-)",
  "1,1,2,2,3,3,4,4,4a,5,5,6,6,7,7,8,8,8aoctadecafluoronaphthalene (Perfluorodecalin (cis)) ; (Z)-C10F18",
  "1,1,2,2,3,3,4,4,4a,5,5,6,6,7,7,8,8,8aoctadecafluoronaphthalene (Perfluorodecalin (trans)) ; (E)-C10F18",
  "1,1,2,3,4,4-hexafluorobuta-1,3-diene ; CF2=CFCF=CF2",
  "Octafluoro-1-butene ; CF3CF2CF=CF2",
  "Octafluoro-2-butene ; CF3CF=CFCF3",
  "CFC-11 ; CCl3F",
  "CFC-12 ; CCl2F2",
  "CFC-13 ; CClF3",
  "CFC-112 ; CCl2FCCl2F",
  "CFC-112a ; CCl3CClF2",
  "CFC-113 ; CCl2FCClF2",
  "CFC-113a ; CCl3CF3",
  "CFC-114 ; CClF2CClF2",
  "CFC-114a ; CCl2FCF3",
  "CFC-115 ; CClF2CF3",
  "E-R316c ; trans cyc (-CClFCF2CF2CClF-)",
  "Z-R316c ; cis cyc (-CClFCF2CF2CClF-)",
  "CFC 1112 ; CClF=CClF",
  "CFC 1112a ; CCl2=CF2",
  "HCFC-21 ; CHCl2F",
  "HCFC-22 ; CHClF2",
  "HCFC-31 ; CH2ClF",
  "HCFC-121 ; CHCl2CCl2F",
  "HCFC-122 ; CHCl2CClF2",
  "HCFC-122a ; CHClFCCl2F",
  "HCFC-123 ; CHCl2CF3",
  "HCFC-123a ; CHClFCClF2",
  "HCFC-124 ; CHClFCF3",
  "HCFC-124a ; CHF2CClF2",
  "HCFC-132 ; CHClFCHClF",
  "HCFC-132a ; CHCl2CHF2",
  "HCFC-132c ; CH2FCCl2F",
  "HCFC-133a ; CH2ClCF3",
  "HCFC-141 ; CH2ClCHClF",
  "HCFC-141b ; CH3CCl2F",
  "HCFC-142b ; CH3CClF2",
  "HCFC-225ca ; CHCl2CF2CF3",
  "HCFC-225cb ; CHClFCF2CClF2",
  "HCFO-1233zd(E) ; (E)-CF3CH=CHCl",
  "HCFO-1233zd(Z) ; (Z)-CF3CH=CHCl",
  "(e)-1-chloro-2-fluoroethene ; (E/Z)-CHCl=CHF",
  "(E)-1-chloro-3,3,3-trifluoroprop-1ene ; trans-CF3CH=CHCl",
  "Methyl chloroform ; CH3CCl3",
  "Carbon tetrachloride ; CCl4",
  "Methyl chloride ; CH3Cl",
  "Methylene chloride ; CH2Cl2",
  "Chloroform ; CHCl3",
  "Chloroethane ; CH3CH2Cl",
  "1,2-dichloroethane ; CH2ClCH2Cl",
  "1,1,2-trichloroethene ; CHCl=CCl2",
  "1,1,2,2-tetrachloroethene ; CCl2=CCl2",
  "2-chloropropane ; CH3CHClCH3",
  "1-chlorobutane ; CH3(CH2)2CH2Cl",
  "Methyl bromide ; CH3Br",
  "Methylene bromide ; CH2Br2",
  "Halon-1201 ; CHBrF2",
  "Halon-1202 ; CBr2F2",
  "Halon-1211 ; CBrClF2",
  "Halon-1301 ; CBrF3",
  "Halon-2301 ; CH2BrCF3",
  "Halon-2311 ; CHBrClCF3",
  "Halon-2401 ; CHBrFCF3",
  "Halon-2402 ; CBrF2CBrF2",
  "Tribromomethane ; CHBr3",
  "Halon-1011 ; CH2BrCl",
  "Bromoethane ; CH3CH2Br",
  "1,2-dibromoethane ; CH2BrCH2Br",
  "1-bromopropane ; CH3CH2CH2Br",
  "2-bromopropane ; CH3CHBrCH3",
  "HFE-125 ; CHF2OCF3",
  "HFE-134 ; CHF2OCHF2",
  "HFE-143a ; CH3OCF3",
  "HFE-227ea ; CF3CHFOCF3",
  "HCFE-235ca2 ; CHF2OCF2CHFCl",
  "HCFE-235da2 ; CHF2OCHClCF3",
  "HFE-236ea2 ; CHF2OCHFCF3",
  "HFE-236fa ; CF3CH2OCF3",
  "HFE-245cb2 ; CF3CF2OCH3",
  "HFE-245fa1 ; CHF2CH2OCF3",
  "HFE-245fa2 ; CHF2OCH2CF3",
  "2,2,3,3,3-pentafluoropropan-1-ol ; CF3CF2CH2OH",
  "HFE-254cb1 ; CH3OCF2CHF2",
  "HFE-254cb2 ; CH3OCF2CHF2",
  "HFE-236ca ; CHF2OCF2CHF2",
  "HFE-263mf (HFE-263fb2) ; CF3CH2OCH3",
  "HFE-263m1 ; CF3OCH2CH3",
  "HFE-365mcf2 ; CF3CF2OCH2CH3",
  "3,3,3-trifluoropropan-1-ol ; CF3CH2CH2OH",
  "HFE-329mcc2 ; CHF2CF2OCF2CF3",
  "HFE-338mmz1 ; (CF3)2CHOCHF2",
  "HFE-338mcf2 ; CF3CH2OCF2CF3",
  "HFE-347mmz1 ; (CF3)2CHOCH2F",
  "HFE-347mcc3 ; CH3OCF2CF2CF3",
  "HFE-347mcf2 ; CHF2CH2OCF2CF3",
  "HFE-347pcf2 ; CHF2CF2OCH2CF3",
  "HFE-347mmy1 ; (CF3)2CFOCH3",
  "HFE-356mec3 ; CH3OCF2CHFCF3",
  "HFE-356mff2 ; CF3CH2OCH2CF3",
  "HFE-356pcf2 ; CHF2CH2OCF2CHF2",
  "HFE-356pcf3 ; CHF2OCH2CF2CHF2",
  "HFE-356pcc3 ; CH3OCF2CF2CHF2",
  "HFE-356mmz1 ; (CF3)2CHOCH3",
  "HFE-365mcf3 ; CF3CF2CH2OCH3",
  "HFE-374pc2 ; CHF2CF2OCH2CH3",
  "4,4,4-trifluorobutan-1-ol ; CF3(CH2)2CH2OH",
  "2,2,3,3,4,4,5,5-octafluorocyclopentan-1-ol; cyc (-(CF2)4CH(OH)-)",
  "HFE-43-10pccc124 ; CHF2OCF2OCF2CF2OCHF2",
  "HFE-449s1 ; C4F9OCH3",
  "HFE-449sl ; C4F9OCH3",
  "n-HFE-7100 ; CF3CF2CF2CF2OCH3",
  "n-HFE-7200 ; n-C4F9OC2H5",
  "i-HFE-7100 ; (CF3)2CFCF2OCH3",
  "HFE-569sf2 ; C4F9OC2H5",
  "i-HFE-7200 ; (CF3)2CFCF2OCH2CH3",
  "HFE-7300 ; (CF3)2CFCFOC2H5CF2CF2CF3",
  "HFE-7500 ; n-C3F7CFOC2H5CF(CF3)2",
  "HFE-236ca12 ; CHF2OCF2OCHF2",
  "HFE-338pcc13 ; CHF2OCF2CF2OCHF2",
  "1,1,1,3,3,3-hexafluoropropan-2-ol ; (CF3)2CHOH",
  "HG-02 ; CHF2(OCF2CF2)2OCHF2",
  "HG-03 ; CHF2(OCF2CF2)3OCHF2",
  "HG-20 ; HF2C–(OCF2)2–OCF2H",
  "HG-21 ; HF2C–OCF2CF2OC-F2OCF2O–CF2H",
  "HG-30 ; HF2C–(OCF2)3–OCF2H",
  "Fluroxene ; CF3CH2OCH=CH2",
  "1,1,2,2-tetrafluoro-1-(fluoromethoxy)ethane; CH2FOCF2CF2H",
  "2-ethoxy-3,3,4,4,5pentafluorotetrahydro-2,5bis[1,2,2,2-tetrafluoro-1(trifluoromethyl)ethyl]furan ; C12H5F19O2",
  "Difluoro(methoxy)methane ; CH3OCHF2",
  "HG’-01 ; CH3OCF2CF2OCH3",
  "HG’-02 ; CH3O(CF2CF2O)2CH3",
  "HG’-03 ; CH3O(CF2CF2O)3CH3",
  "HFE-329me3 ; CF3CFHCF2OCF3",
  "3,3,4,4,5,5,6,6,7,7,7undecafluoroheptan-1-ol ; CF3(CF2)4CH2CH2OH",
  "3,3,4,4,5,5,6,6,7,7,8,8,9,9,9pentadecafluorononan-1-ol ; CF3(CF2)6CH2CH2OH",
  "3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,11-nonadecafluoroundecan-1-ol; CF3(CF2)8CH2CH2OH",
  "2-chloro-1,1,2-trifluoro-1methoxyethane ; CH3OCF2CHClF",
  "PFPMIE ; CF3OCF(CF3)CF2OCF2OCF3",
  "HFE-216 ; CF3OCF=CF2",
  "Perfluoroethyl formate ; CF3CF2OCHO",
  "2,2,2-trifluoroethyl formate ; CF3CH2OCHO",
  "Formic acid;1,1,1,3,3,3-hexafluoropropan-2-ol ; (CF3)2CHOCHO",
  "Ethenyl 2,2,2-trifluoroacetate ; CF3COOCH=CH2",
  "Ethyl 2,2,2-trifluoroacetate ; CF3COOCH2CH3",
  "Prop-2-enyl-2,2,2-trifluoroacetate ; CF3COOCH2CH=CH2",
  "Methyl 2,2,2-trifluoroacetate ; CF3COOCH3",
  "2,2,3,3,4,4,4-heptafluorobutan-1-ol ; CF3CF2CF2CH2OH",
  "1,1,2-trifluoro-2-(trifluoromethoxy)ethane ; CHF2CHFOCF3",
  "1-ethoxy-1,1,2,3,3,3hexafluoropropane ; CF3CHFCF2OCH2CH3",
  "1,1,1,2,2,3,3-heptafluoro-3-(1,2,2,2tetrafluoroethoxy)propane ; CF3CF2CF2OCHFCF3",
  "2,2,3,3-tetrafluoropropan-1-ol ; CHF2CF2CH2OH",
  "2,2,3,4,4,4-hexafluorobutan-1-ol ; CF3CHFCF2CH2OH",
  "1,1,2,2-tetrafluoro-3methoxypropane ; CHF2CF2CH2OCH3",
  "1,1,1,2,2,4,5,5,5-nonafluoro-4-(trifluoromethyl)pentan-3-one; CF3CF2COCF(CF3)2",
  "3,3,3-trifluoropropanal ; CF3CH2CHO",
  "2-fluoroethanol ; CH2FCH2OH",
  "2,2-difluoroethanol ; CHF2CH2OH",
  "2,2,2-trifluoroethanol ; CF3CH2OH",
  "HG-04 ; CHF2O(CF2CF2O)4CHF2",
  "Methyl-perfluoro-heptene-ethers ; CH3OC7F13",
  "1,1,1-trifluoro-propan-2-one ; CF3COCH3",
  "1,1,1-trifluoro-butan-2-one ; CF3COCH2CH3",
  "1-chloro-2-ethen-oxyethane ; ClCH2CH2OCH=CH2",
  "Octafluoro-oxolane ; c-C4F8O",
];

export const griStructure = {
  series200: {
    label: "200 Series",
    groups: {
      gri201: {
        label: "GRI 201",
        pages: ["gri201_1", "gri201_2", "gri201_3", "gri201_4"],
      },
      gri202: {
        label: "GRI 202",
        pages: ["gri202_1", "gri202_2"],
      },
      gri203: {
        label: "GRI 203",
        pages: ["gri203_1", "gri203_2"],
      },
      gri204: {
        label: "GRI 204",
        pages: ["gri204_1"],
      },
      gri205: {
        label: "GRI 205",
        pages: ["gri205_1", "gri205_2", "gri205_3"],
      },
      gri206: {
        label: "GRI 206",
        pages: ["gri206_1"],
      },
      gri418: {
        label: "GRI 418",
        pages: ["gri418"],
      },
      gri207: {
        label: "GRI 207",
        pages: ["gri207_1", "gri207_2", "gri207_3", "gri207_4"],
      },
    },
  },
};

export const griStructure300 = {
  series300: {
    label: "300 Series",
    groups: {
      gri301: {
        label: "GRI 301",
        pages: ["gri301_1", "gri301_2", "gri301_3"],
      },
      gri302: {
        label: "GRI 302",
        pages: ["gri302_1", "gri302_2", "gri302_3", "gri302_4", "gri302_5"],
      },
      gri303: {
        label: "GRI 303",
        pages: ["gri303_1", "gri303_2", "gri303_3", "gri303_4", "gri303_5"],
      },
      gri304: {
        label: "GRI 304 ",
        pages: ["gri304_1", "gri304_2", "gri304_3", "gri304_4"],
      },
      gri305: {
        label: "GRI 305 ",
        pages: [
          "gri305_1",
          "gri305_2",
          "gri305_3",
          "gri305_4",
          "gri305_5",
          "gri305_6",
          "gri305_7",
        ],
      },
      gri306: {
        label: "GRI 306 ",
        pages: ["gri306_1", "gri306_2", "gri306_3", "gri306_4", "gri306_5"],
      },
      gri308: {
        label: "GRI 308 ",
        pages: ["gri308_1", "gri308_2"],
      },
    },
  },
};

export const griStructure400 = {
  series400: {
    label: "400 Series",
    groups: {
      gri401: {
        label: "GRI 401",
        pages: ["gri401_1", "gri401_2", "gri401_3"],
      },
      gri402: {
        label: "GRI 402",
        pages: ["gri402"],
      },
      gri403: {
        label: "GRI 403",
        pages: [
          "gri403_1",
          "gri403_2",
          "gri403_3",
          "gri403_4",
          "gri403_5",
          "gri403_6",
          "gri403_7",
          "gri403_8",
          "gri403_9",
          "gri403_10",
        ],
      },
      gri404: {
        label: "GRI 404",
        pages: ["gri404_1", "gri404_2", "gri404_3"],
      },
      gri405: {
        label: "GRI 405 ",
        pages: ["gri405_1", "gri405_2"],
      },
      gri406: {
        label: "GRI 406",
        pages: ["gri406"],
      },
      gri407: {
        label: "GRI 407",
        pages: ["gri407"],
      },
      gri408: {
        label: "GRI 408",
        pages: ["gri408"],
      },
      gri409: {
        label: "GRI 409",
        pages: ["gri409"],
      },
      gri410: {
        label: "GRI 410",
        pages: ["gri410"],
      },
      gri411: {
        label: "GRI 411",
        pages: ["gri411"],
      },
      gri413: {
        label: "GRI 413 ",
        pages: ["gri413_1", "gri413_2"],
      },
      gri414: {
        label: "GRI 414 ",
        pages: ["gri414_1", "gri414_2"],
      },
      gri415: {
        label: "GRI 415",
        pages: ["gri415"],
      },
      gri416: {
        label: "GRI 416 ",
        pages: ["gri416_1", "gri416_2"],
      },
      gri417: {
        label: "GRI 417 ",
        pages: ["gri417_1", "gri417_2", "gri417_3"],
      },
      gri418: {
        label: "GRI 418",
        pages: ["gri418"],
      },
    },
  },
};

export const productCategoryOptions = [
  "Aggregates",
  "Average construction",
  "Asbestos",
  "Asphalt",
  "Bricks",
  "Concrete",
  "Insulation",
  "Metals",
  "Soils",
  "Mineral oil",
  "Plasterboard",
  "Tyres",
  "wood",
  "Books",
  "Glass",
  "Clothing",
  "Household residual waste",
  "Organic: food and drink waste",
  "Organic: garden waste",
  "Organic: mixed food and garden waste",
  "Commercial and industrial waste",
  "WEEE - fridges and freezers",
  "WEEE - large",
  "WEEE - mixed",
  "WEEE - small",
  "Batteries",
  "Metal: aluminium cans and foil (excl. forming)",
  "Metal: mixed cans",
  "Metal: scrap metal",
  "Metal: steel cans",
  "Plastics: average plastics",
  "Plastics: average plastic film",
  "Plastics: average plastic rigid",
  "Plastics: HDPE (incl. forming)",
  "Plastics: LDPE and LLDPE (incl. forming)",
  "Plastics: PET (incl. forming)",
  "Plastics: PP (incl. forming)",
  "Plastics: PS (incl. forming)",
  "Plastics: PVC (incl. forming)",
  "Paper and board: board",
  "Paper and board: mixed",
  "Paper and board: paper",
];
